import { extractChannel } from '../tools';

/**
 * 数据源管理上下文
 */
export default class DataSourceContext {
  constructor(config) {
    this.config = config;
    this.setDataSourceController();
  }

  /**
   * 实例化控制器
   */
  setDataSourceController() {
    const context = require.context('./channel-interface', false, /DataSourceController\.js$/);
    for (const key of context.keys()) {
      if (this.config.init_ops.channel_interface === extractChannel(key, 'DataSourceController')) {
        const Controller = context(key).default;
        this.controller = new Controller(this.config);
        break;
      }
    }
    if (!this.controller) {
      throw new Error('Unsupported channel type.');
    }
  }

  /**
   * 获取控制器
   */
  getDataSourceController() {
    return this.controller;
  }
}
